import React, { useEffect, useState } from "react";

import api from "../../services/api";
import { onlyNumbers } from "../../services/onlyNumber";
import { rucFormater } from "../../services/rucFormater";
import { cpfCnpjFormater } from "../../services/cpfCnpjFormater";
import { stringWithoutCaracteres } from "../../services/stringWithoutCaracteres";

import Brasil from "../../assets/image/brasil.webp";
import Paraguai from "../../assets/image/paraguai.webp";

import UsersCompanyModal from "./UsersCompanyModal";

import PageContainer from "../../containers/PageContainer";

import { User } from "../../models/entities/user";
import { Company } from "../../models/entities/company";
import { UserLevelDisplay } from "../../models/enums/UserLevelDisplay";

import { Empty, notification, Table, Tooltip } from "antd";

import {
  ActionButtonsContainer,
  BoxSearch,
  Button,
  CardContainer,
  Container,
  ContainerSearch,
  Country,
  Input,
  SearchIcon,
  Select,
  StatusSpan,
} from "./styles";
import { removeAccentsAndLowerCase } from "../../helpers/removeAccentsAndCaseSensitive";

interface IFiltersCompany {
  company_name: string;
  company_template_status: string;
}
interface IFiltersUser {
  user_name: string;
  user_template_track_status: string;
  user_cpf: string;
  user_profile: number | undefined;
  user_level: number | undefined;
}

interface IBranchGroups {
  id: number;
  name: string;
}

const TemplateTrack: React.FC = () => {
  const [loading, setLoading] = useState<boolean>(false);
  const [shouldSearch, setShouldSearch] = useState<boolean>(true);
  const [reloadGroup, setReloadGroup] = useState<boolean>(true);

  const [openModalUsersCompany, setOpenModalUsersCompany] =
    useState<boolean>(false);

  const [changeCompanyUsers, setChangeCompanyUsers] = useState<number>(1);

  const [branchGroupsList, setBranchGroupsList] = useState<IBranchGroups[]>([]);

  const [profiles, setProfiles] = useState<{ id: number; name: string }[]>([]);

  const [filtersCompany, setFiltersCompany] = useState<IFiltersCompany>({
    company_name: "",
    company_template_status: "",
  });

  const [filtersUser, setFiltersuser] = useState<IFiltersUser>({
    user_name: "",
    user_template_track_status: "",
    user_cpf: "",
    user_profile: undefined,
    user_level: undefined,
  });

  const [selectedCompany, setSelectedCompany] = useState<Company>();

  const [companies, setCompanies] = useState<Company[]>([]);
  const [filteredCompanies, setFilteredCompanies] = useState<Company[]>([]);

  const [users, setUsers] = useState<User[]>([]);
  const [filteredUsers, setFilteredUsers] = useState<User[]>([]);

  //profiles

  useEffect(() => {
    fetchProfiles();
  }, []);

  const fetchProfiles = async () => {
    try {
      const {
        data: { content },
      } = await api.get("/user?is_profile=true");
      if (content) {
        const profilesData = content.map((profile: any) => ({
          id: profile.id,
          name: profile.name,
        }));
        setProfiles(
          profilesData.sort((a: any, b: any) => a.name.localeCompare(b.name))
        );
      }
    } catch (e) {
      const _description =
        //@ts-ignore
        e?.response?.data?.message || "";
      notification.error({
        message: "Um erro inesperado ocorreu!",
        description: _description,
        duration: 5,
      });
    }
  };

  //template groups

  useEffect(() => {
    if (reloadGroup) fetchBranchGroups();
  }, [reloadGroup]);

  const fetchBranchGroups = async () => {
    try {
      const { data } = await api.get(
        "/template-track/branch/list-branch-groups"
      );
      setBranchGroupsList(data.content.branchGroups || []);
    } catch (error: any) {
      console.error(error.response?.data?.message);
    } finally {
      setReloadGroup(false);
    }
  };

  //companies

  useEffect(() => {
    if (changeCompanyUsers === 1 && shouldSearch) fetchCompanies();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldSearch, changeCompanyUsers]);

  const fetchCompanies = async () => {
    try {
      setLoading(true);
      const { data } = await api.get("/company");
      setCompanies(data.content || []);
      setShouldSearch(false);
    } catch (error: any) {
      notification.error({
        message: "Um erro inesperado ocorreu!",
        description: error.response?.data?.message || "Erro ao buscar lojas",
        duration: 5,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const filterCompanies = () => {
      let _filterCompany: Company[] = [...companies];
      if (filtersCompany.company_name) {
        const normalizedPattern = removeAccentsAndLowerCase(
          filtersCompany.company_name.toString()
        );
        const patternOnlyAlnum =
          stringWithoutCaracteres(normalizedPattern || "") || "";

        _filterCompany = _filterCompany.filter((_company) => {
          const normalizedCompanyName = removeAccentsAndLowerCase(
            _company?.company_name || ""
          );
          const normalizedCnpjOrRuc = removeAccentsAndLowerCase(
            _company?.cnpj || _company?.ruc || ""
          );
          const cnpjOrRucOnlyAlnum =
            stringWithoutCaracteres(normalizedCnpjOrRuc || "") || "";

          return (
            normalizedCompanyName.includes(normalizedPattern) ||
            normalizedCnpjOrRuc.includes(normalizedPattern) ||
            (patternOnlyAlnum !== "" &&
              cnpjOrRucOnlyAlnum.includes(patternOnlyAlnum))
          );
        });
      }
      if (filtersCompany.company_template_status) {
        _filterCompany = _filterCompany.filter((_company) =>
          filtersCompany.company_template_status === "active"
            ? _company.template_track_id
            : !_company.template_track_id
        );
      }

      setFilteredCompanies([..._filterCompany]);
    };

    filterCompanies();
  }, [companies, filtersCompany]);

  const findCompany = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    setFiltersCompany((oldValues) => ({
      ...oldValues,
      company_name: value || "",
    }));
  };

  const registerTemplate = async (_companySelect) => {
    try {
      setLoading(true);

      let findBranchId =
        branchGroupsList?.find((_group) =>
          _group?.name?.includes(_companySelect.emitente_uf)
        )?.id || undefined;

      if (!findBranchId) {
        const {
          data: { content },
        } = await api.post(`/template-track/branch/create-branch-groups`, {
          name: `US_${_companySelect?.emitente_uf}`,
        });

        findBranchId = content.id;
        setReloadGroup(true);
      }
      await api.post(`/template-track/create-branches/${_companySelect?.id}`, {
        branchGroupIds: findBranchId,
      });

      notification.success({
        message: `Empresa vinculada com sucesso`,
        duration: 5,
      });
      setShouldSearch(true);
    } catch (e) {
      const _description =
        //@ts-ignore
        e?.content?.data?.message;

      notification.error({
        message: "Um erro inesperado ocorreu",
        description: _description || "",
        duration: 5,
      });
      setLoading(false);
    }
  };

  //users

  useEffect(() => {
    if (changeCompanyUsers === 2 && shouldSearch) fetchUsers();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shouldSearch, changeCompanyUsers]);

  const fetchUsers = async () => {
    try {
      setLoading(true);
      const { data } = await api.get("/user");
      setUsers(data.content || []);

      setShouldSearch(false);
    } catch (error: any) {
      notification.error({
        message: "Um erro inesperado ocorreu!",
        description:
          error.response?.data?.message || "Erro ao buscar os usuários",
        duration: 5,
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const filterUsers = () => {
      let _filterUser: User[] = [...users];
      if (filtersUser.user_cpf) {
        _filterUser = _filterUser.filter(
          (_user) => _user.cpf === filtersUser.user_cpf
        );
      }
      if (filtersUser.user_name) {
        _filterUser = _filterUser.filter((_user) =>
          removeAccentsAndLowerCase(_user?.full_name || "")?.includes(
            removeAccentsAndLowerCase(filtersUser?.user_name?.toString() || "")
          )
        );
      }
      if (typeof filtersUser.user_profile === "number") {
        _filterUser = _filterUser.filter(
          (_user) => _user?.profile === filtersUser.user_profile
        );
      }
      if (typeof filtersUser.user_level === "number") {
        _filterUser = _filterUser.filter(
          (_user) => _user?.level === filtersUser.user_level
        );
      }
      if (filtersUser.user_template_track_status) {
        _filterUser = _filterUser.filter((_user) =>
          filtersUser.user_template_track_status === "active"
            ? _user?.user_template_track_status
            : !_user?.user_template_track_status
        );
      }

      setFilteredUsers([..._filterUser]);
    };

    filterUsers();
  }, [users, filtersUser]);

  const findUser = (e: React.ChangeEvent<HTMLInputElement>) => {
    const value = e.target.value;
    if (value) {
      if (onlyNumbers(value)?.toString().length === 11) {
        setFiltersuser((oldValues) => ({
          ...oldValues,
          user_name: "",
          user_cpf: onlyNumbers(value)?.toString() || "",
        }));
      } else {
        setFiltersuser((oldValues) => ({
          ...oldValues,
          user_name: value,
          user_cpf: "",
        }));
      }
    } else {
      setFiltersuser((oldValues) => ({
        ...oldValues,
        user_name: "",
        user_cpf: "",
      }));
    }
  };

  const deleteUserTemplate = async (_userSelect: User) => {
    try {
      setLoading(true);
      await api.delete(
        `/template-track/users/${_userSelect.template_track_username}`
      );

      notification.success({
        message: `Usuário removido com sucesso`,
        duration: 5,
      });
      setShouldSearch(true);
    } catch (e) {
      const _description =
        //@ts-ignore
        e?.content?.data?.message;

      notification.error({
        message: "Erro ao remover usuário na template track",
        description: _description || "",
        duration: 5,
      });
      setLoading(false);
    }
  };

  //tabelas

  const getCompanyNames = (userCompanies) => {
    const find_company_names = companies
      .filter((_company) => userCompanies?.some((id) => id === _company.id))
      .map((_company) =>
        _company?.company_name
          ?.split(" ")
          .map(
            (name) => name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()
          )
          .join(" ")
      );

    return find_company_names.join(" , ");
  };

  const columnsCompanies = [
    {
      title: "ID",
      dataIndex: "id",
      width: "5%",
      key: "id",
    },
    {
      title: "País",
      dataIndex: "country",
      key: "country",
      width: "5%",
      render: (text) => (
        <>
          {text === "brasil" ? (
            <Tooltip title="Brasil">
              <Country src={Brasil}></Country>
            </Tooltip>
          ) : (
            <Tooltip title="Paraguai">
              <Country src={Paraguai}></Country>
            </Tooltip>
          )}
        </>
      ),
    },
    {
      title: "Nome",
      dataIndex: "company_name",
      key: "company_name",
      width: "15%",
      render: (text) => (
        <span style={{ textTransform: "capitalize" }}>{text}</span>
      ),
    },
    {
      title: "CNPJ / RUC",
      dataIndex: "cnpj",
      key: "cnpj",
      width: "12%",
      render: (text, record) => {
        if (record?.country === "brasil") {
          return cpfCnpjFormater(record?.cnpj);
        } else if (record?.country === "paraguai") {
          return rucFormater(record?.ruc);
        }
        return "CNPJ/RUC não foi enviado";
      },
    },
    {
      title: "Cidade",
      dataIndex: "city",
      key: "city",
      width: "12%",
      render: (text) => (
        <span style={{ textTransform: "capitalize" }}>
          {text ? text : "Indefinida"}
        </span>
      ),
    },
    {
      title: "Status",
      dataIndex: "template_track_id",
      key: "template_track_id",
      width: "12%",
      render: (text) => (
        <StatusSpan status={text ? "success" : "error"}>
          {text ? "Ativo" : "Não Cadastrado"}
        </StatusSpan>
      ),
    },
    {
      title: "Ações",
      key: "actions",
      width: "10%",
      render: (_, record) => (
        <>
          {!record.template_track_id ? (
            <Button
              actionType="activate"
              type="primary"
              onClick={() => registerTemplate(record)}
              style={{ marginRight: 8 }}
              loading={loading}
            >
              Vincular Empresa
            </Button>
          ) : (
            <Button
              actionType="send"
              type="primary"
              onClick={() => {
                setOpenModalUsersCompany(true);
                setSelectedCompany(record);
              }}
              style={{ marginRight: 8 }}
              loading={loading}
            >
              Vincular Usuário
            </Button>
          )}
        </>
      ),
    },
  ];

  const columnsUsers = [
    {
      title: "ID",
      dataIndex: "id",
      key: "id",
      width: "7%",
    },

    {
      title: "Nome",
      dataIndex: "full_name",
      key: "full_name",
      width: "18%",
      ellipsis: true,
      render: (text: string) => (
        <Tooltip title={text}>
          <span>{text}</span>
        </Tooltip>
      ),
    },
    {
      title: "Nível",
      dataIndex: "level",
      key: "level",
      width: "10%",
      ellipsis: true,
      render: (_: any, record: User) => {
        const levelName =
          UserLevelDisplay.find((level) => level.value === record.level)
            ?.label || "Nível não definido";
        return (
          <Tooltip title={levelName}>
            <span>{levelName}</span>
          </Tooltip>
        );
      },
    },
    {
      title: "Cargo",
      dataIndex: "profile",
      key: "profile",
      width: "12%",
      ellipsis: true,
      render: (_: any, record: User) => {
        const userProfile = profiles?.find(
          (profile) => profile.id === record.profile
        );
        const profileName = userProfile?.name || "Sem cargo definido";
        return (
          <Tooltip title={profileName}>
            <span>{profileName}</span>
          </Tooltip>
        );
      },
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "email",
      width: "12%",
      ellipsis: true,
      render: (text: string) => (
        <Tooltip title={text}>
          <span>{text}</span>
        </Tooltip>
      ),
    },
    {
      title: "Status Template",
      dataIndex: "user_template_track_status",
      key: "user_template_track_status",
      width: "12%",
      ellipsis: true,
      render: (text) => (
        <StatusSpan status={text ? "success" : "error"}>
          {text ? "Ativo" : "Não cadastrado"}
        </StatusSpan>
      ),
    },

    {
      title: "Qtd de Lojas",
      dataIndex: "user_template_track_stores",
      key: "user_template_track_stores",
      width: "10%",
      ellipsis: true,
      render: (text) => (
        <Tooltip title={getCompanyNames(text)}>
          <StatusSpan status="info">
            {text?.length ? `${text.length} lojas` : "Sem lojas"}
          </StatusSpan>
        </Tooltip>
      ),
    },
    {
      title: "Ações",
      key: "actions",
      width: "10%",
      render: (_: any, record: User) =>
        record.user_template_track_status && (
          <Button
            actionType="inactivate"
            type="primary"
            onClick={() => {
              deleteUserTemplate(record);
            }}
            loading={loading}
          >
            Desativar
          </Button>
        ),
    },
  ];

  const filterCompanyList = (_company) => {
    if (_company.company_status) {
      return true;
    }
    if (
      !_company.company_status &&
      (_company?.company_reason?.includes("Em montagem") ||
        _company?.company_reason?.includes("Em Implantação"))
    ) {
      if (
        _company.physical_state_registration &&
        _company.physical_city &&
        _company.country &&
        _company.physical_address &&
        _company.physical_number
      ) {
        return true;
      } else {
        return false;
      }
    }

    return false;
  };

  return (
    <PageContainer route="Integração com a Template Track">
      <Container>
        <CardContainer>
          <ContainerSearch>
            {changeCompanyUsers === 1 ? (
              <BoxSearch>
                <Input
                  placeholder="Buscar por nome ou cnpj"
                  onChange={(e) => findCompany(e)}
                  prefix={<SearchIcon />}
                  disabled={loading}
                  allowClear
                />
                <Select
                  placeholder="Filtrar por status"
                  value={filtersCompany.company_template_status}
                  onChange={(value) =>
                    setFiltersCompany((oldValues) => ({
                      ...oldValues,
                      company_template_status: value as string,
                    }))
                  }
                  disabled={loading}
                >
                  <Select.Option value="">Todos</Select.Option>
                  <Select.Option value="active">Ativos</Select.Option>
                  <Select.Option value="not_registered">
                    Não Cadastrados
                  </Select.Option>
                </Select>
              </BoxSearch>
            ) : (
              <BoxSearch>
                <Input
                  placeholder="Buscar por nome ou CPF"
                  onChange={(e) => findUser(e)}
                  prefix={<SearchIcon />}
                  disabled={loading}
                  allowClear
                />
                <Select
                  placeholder="Filtrar por status"
                  value={filtersUser.user_template_track_status}
                  onChange={(value) =>
                    setFiltersuser((oldValues) => ({
                      ...oldValues,
                      user_template_track_status: value as string,
                    }))
                  }
                  disabled={loading}
                >
                  <Select.Option value="">Todos</Select.Option>
                  <Select.Option value="active">Ativos</Select.Option>
                  <Select.Option value="not_registered">
                    Não Cadastrados
                  </Select.Option>
                </Select>
                <Select
                  showSearch
                  allowClear
                  placeholder="Filtrar por cargo"
                  value={filtersUser.user_profile}
                  onChange={(value) =>
                    setFiltersuser((oldValues) => ({
                      ...oldValues,
                      user_profile: value as number,
                    }))
                  }
                  disabled={loading}
                  filterOption={(input, option) =>
                    typeof option?.children === "string" &&
                    option.children
                      .toLowerCase()
                      .indexOf(input.toLowerCase()) >= 0
                  }
                  defaultActiveFirstOption={false}
                  showArrow={false}
                >
                  {profiles.map((profile) => (
                    <Select.Option key={profile.id} value={profile.id}>
                      {profile.name}
                    </Select.Option>
                  ))}
                </Select>
                <Select
                  allowClear
                  placeholder="Filtrar por nível"
                  value={filtersUser.user_level}
                  onChange={(value) =>
                    setFiltersuser((oldValues) => ({
                      ...oldValues,
                      user_level: value as number,
                    }))
                  }
                  disabled={loading}
                >
                  {UserLevelDisplay.map((level) => (
                    <Select.Option key={level.value} value={level.value}>
                      {level.label}
                    </Select.Option>
                  ))}
                </Select>
              </BoxSearch>
            )}
            <ActionButtonsContainer>
              <Button
                actionType="update_magic_link"
                type="primary"
                onClick={() => {
                  setChangeCompanyUsers(changeCompanyUsers === 1 ? 2 : 1);
                  setShouldSearch(true);
                }}
              >
                {changeCompanyUsers === 1
                  ? "Listar Usuários"
                  : "Listar Empresas"}
              </Button>
            </ActionButtonsContainer>
          </ContainerSearch>
        </CardContainer>
        {changeCompanyUsers === 1 ? (
          <Table
            columns={columnsCompanies}
            dataSource={filteredCompanies.filter((_company) =>
              filterCompanyList(_company)
            )}
            rowKey="id"
            loading={loading}
            scroll={{ y: 500 }}
            locale={{
              emptyText: <Empty description="Nenhuma loja encontrada" />,
            }}
          />
        ) : (
          <Table
            columns={columnsUsers}
            dataSource={filteredUsers}
            rowKey="id"
            loading={loading}
            scroll={{ y: 500 }}
            locale={{
              emptyText: <Empty description="Nenhum usuário encontrado" />,
            }}
          />
        )}
      </Container>

      <UsersCompanyModal
        visible={openModalUsersCompany}
        setVisible={setOpenModalUsersCompany}
        company={selectedCompany}
        profiles={profiles}
      />
    </PageContainer>
  );
};

export default TemplateTrack;
